import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Card, Heading, HStack, Icon, Separator, SimpleGrid, Tabs, Text, VStack } from '@chakra-ui/react';
import { SlideIssues } from '@src/components/sco/PitchDeckAuditor/main/SlideIssues';
import { SuggestedRewriteCard } from '@src/components/sco/PitchDeckAuditor/main/SuggestedRewriteCard';
import { PitchSlideView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { RatingBadge } from '@src/components/sco/PitchDeckAuditor/nav/RatingBadge';
import { SlideThumb } from '@src/components/sco/PitchDeckAuditor/nav/SlideThumb';
import { ScoreRing } from '@src/components/sco/PitchDeckAuditor/shared/ScoreRing';
import { SectionHeading } from '@src/components/sco/PitchDeckAuditor/shared/SectionHeading';
import { ReactNode } from 'react';
import { LuCheck, LuMessageSquareQuote, LuPencilLine, LuThumbsDown, LuThumbsUp, LuTriangleAlert } from 'react-icons/lu';
import { useBreakpointContext } from '../../utilities/BreakpointProvider';
export function SlideDetail(t0) {
  const $ = _c(49);
  const {
    slide,
    slideCount,
    onAccept,
    onClear,
    accepting: t1,
    locked: t2,
    lockedContent: t3
  } = t0;
  const accepting = t1 === undefined ? false : t1;
  const locked = t2 === undefined ? false : t2;
  const lockedContent = t3 === undefined ? null : t3;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t4;
  if ($[0] !== getBreakpointValue) {
    t4 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const isMobile = t4;
  const rewriteText = slide.acceptedRewrite || slide.suggestedRewrite;
  let t5;
  if ($[2] !== isMobile || $[3] !== slide) {
    t5 = !isMobile && <SlideThumb slide={slide} width="280px" />;
    $[2] = isMobile;
    $[3] = slide;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== slide.position || $[6] !== slideCount) {
    t6 = <HStack gap={2}><Text color="colorPalette.fg/50" textStyle="labelXs">Slide {slide.position} of {slideCount}</Text></HStack>;
    $[5] = slide.position;
    $[6] = slideCount;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isMobile ? "2xl" : "4xl";
  const t8 = slide.classificationLabel || `Slide ${slide.position}`;
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <Heading mt={1} size={t7}>{t8}</Heading>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== slide.ratingKey || $[12] !== slide.ratingLabel) {
    t10 = <RatingBadge label={slide.ratingLabel} ratingKey={slide.ratingKey} size="md" />;
    $[11] = slide.ratingKey;
    $[12] = slide.ratingLabel;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== slide.acceptedRewrite) {
    t11 = slide.acceptedRewrite && <Badge colorPalette="green" size="sm" variant="subtle"><LuCheck />Rewrite accepted</Badge>;
    $[14] = slide.acceptedRewrite;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11) {
    t12 = <HStack gap={3} mt={2}>{t10}{t11}</HStack>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t6 || $[21] !== t9) {
    t13 = <Box flex={1} minWidth="240px">{t6}{t9}{t12}</Box>;
    $[19] = t12;
    $[20] = t6;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== isMobile || $[24] !== slide.score) {
    t14 = slide.score !== null && <ScoreRing headingSize="3xl" score={slide.score} size={isMobile ? "3xl" : "4xl"} />;
    $[23] = isMobile;
    $[24] = slide.score;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13 || $[27] !== t14 || $[28] !== t5) {
    t15 = <HStack align="center" gap={6}>{t5}{t13}{t14}</HStack>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t5;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== isMobile || $[31] !== slide) {
    t16 = isMobile && <SlideThumb slide={slide} width="full" />;
    $[30] = isMobile;
    $[31] = slide;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t15 || $[34] !== t16) {
    t17 = <VStack align="stretch" gap={6}>{t15}{t16}</VStack>;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== accepting || $[37] !== isMobile || $[38] !== locked || $[39] !== lockedContent || $[40] !== onAccept || $[41] !== onClear || $[42] !== rewriteText || $[43] !== slide) {
    t18 = locked ? <><Separator />{lockedContent}</> : !slide.isAudited ? <Card.Root variant="subtle"><Card.Body><Text color="fg.muted" fontSize="sm">This slide isn’t part of the 9-slide framework, so it wasn’t audited. Nothing to fix here — cover and closing slides just need to stay out of the way.</Text></Card.Body></Card.Root> : <><Separator /><Tabs.Root fitted={true} defaultValue="as-written" variant="enclosed"><Tabs.List><Tabs.Trigger value="as-written"><Icon as={LuMessageSquareQuote} boxSize={4} />What you wrote</Tabs.Trigger>{rewriteText && <Tabs.Trigger value="suggested-rewrite"><Icon as={LuPencilLine} boxSize={4} />Suggested rewrite{slide.acceptedRewrite && <Badge alignItems="center" colorPalette="green" display="flex" height="16px" justifyContent="center" ml={1} rounded="full" size="xs" variant="solid" width="16px"><LuCheck /></Badge>}</Tabs.Trigger>}</Tabs.List><Tabs.Content pt={4} value="as-written"><VStack align="stretch" gap={4}>{(slide.currentText || slide.whatTheySaid || slide.whatWorks || slide.whatsMissingOrBroken) && <Card.Root variant="subtle"><Card.Body gap={isMobile ? 4 : 6} padding={isMobile ? 4 : 8}><SectionHeading icon={LuMessageSquareQuote} textStyle="lg">What you wrote</SectionHeading>{(slide.currentText || slide.whatTheySaid) && <Text fontFamily="longform" fontSize="lg" fontStyle="italic">“{slide.currentText || slide.whatTheySaid}”</Text>}{(slide.whatWorks || slide.whatsMissingOrBroken) && <><SimpleGrid columns={{
                    base: 1,
                    lg: 2
                  }} gap={4}>{slide.whatWorks && <Card.Root borderTopColor="teal.solid" borderTopWidth="3px" size="sm"><Card.Body><HStack color="teal.fg" gap={2} mb={1.5}><Icon as={LuThumbsUp} boxSize={4} /><Text textStyle="labelXs">What works</Text></HStack><Text color="fg.muted" fontSize="sm" fontWeight="medium">{slide.whatWorks}</Text></Card.Body></Card.Root>}{slide.whatsMissingOrBroken && <Card.Root borderTopColor="red.solid" borderTopWidth="3px" size="sm"><Card.Body><HStack color="red.fg" gap={2} mb={1.5}><Icon as={LuThumbsDown} boxSize={4} /><Text textStyle="labelXs">What needs work</Text></HStack><Text color="fg.muted" fontSize="sm" fontWeight="medium">{slide.whatsMissingOrBroken}</Text></Card.Body></Card.Root>}</SimpleGrid></>}{slide.issues.length > 0 && <><Separator /><VStack align="stretch" borderRadius="md" gap={4}><SectionHeading icon={LuTriangleAlert} textStyle="lg">Top Problems</SectionHeading><SlideIssues issues={slide.issues} /></VStack></>}</Card.Body></Card.Root>}</VStack></Tabs.Content>{rewriteText && <Tabs.Content pt={4} value="suggested-rewrite"><VStack align="stretch" gap={4}><SuggestedRewriteCard loading={accepting} slide={slide} onAccept={onAccept} onClear={onClear} /></VStack></Tabs.Content>}</Tabs.Root></>;
    $[36] = accepting;
    $[37] = isMobile;
    $[38] = locked;
    $[39] = lockedContent;
    $[40] = onAccept;
    $[41] = onClear;
    $[42] = rewriteText;
    $[43] = slide;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Box pb={4} />;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t17 || $[47] !== t18) {
    t20 = <VStack align="stretch" gap={6}>{t17}{t18}{t19}</VStack>;
    $[46] = t17;
    $[47] = t18;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  return t20;
}